import React from "react";
import {
  Box,
  Card,
  CardContent,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import { GARANZIE_PREZZI } from "../../constants";

const CardGaranziaOpzionale = ({
  garanzia,
  vitaGaranzie,
  onToggle,
  title,
  priceKey,
}) => {
  return (
    <Card
      sx={{
        mb: 2,
        borderRadius: 3,
        border: vitaGaranzie[garanzia].enabled
          ? "2px solid #13b86d"
          : "2px solid transparent",
        bgcolor: (theme) =>
          vitaGaranzie[garanzia].enabled
            ? theme.palette.mode === "dark"
              ? "rgba(19, 184, 109, 0.15)"
              : "rgba(19, 184, 109, 0.08)"
            : theme.palette.mode === "dark"
            ? "rgba(255,255,255,0.05)"
            : "#f8f9fa",
        transition: "all 0.3s ease",
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Stack direction="row" spacing={2} alignItems="center">
            <Switch
              checked={vitaGaranzie[garanzia].enabled}
              onChange={onToggle(garanzia)}
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                  color: "#13b86d",
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  backgroundColor: "#13b86d",
                },
              }}
            />
            <Box>
              <Typography variant="h6" fontWeight={700}>
                {title}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Durata: {vitaGaranzie[garanzia].durata} anni - Capitale:{" "}
                {vitaGaranzie[garanzia].capitale.toLocaleString()}€
              </Typography>
            </Box>
          </Stack>
          <Box textAlign="right">
            <Typography variant="h5" fontWeight={700}>
              {GARANZIE_PREZZI[priceKey].toFixed(2)}€
            </Typography>
            <Typography variant="caption" color="text.secondary">
              all'anno
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CardGaranziaOpzionale;
